import useHasPermission from "@hooks/useHasPermission";
import React from "react";
var RequirePermission = function (props) {
    var permission = props.permission, children = props.children;
    var hasPermission = useHasPermission();
    return React.createElement(React.Fragment, null, hasPermission(permission) && children);
};
export default RequirePermission;
